module.exports = "images/get-inspired-11.webp";